import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

const Unauthorized: React.FC = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center text-red-500">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('errors.unauthorized')}</h2>
        <p className="text-gray-600 mb-6">
          {t('errors.noPermission')}
          {userData && (
            <span> {t('errors.currentRole')} <span className="font-medium capitalize">{t(`roles.${userData.role}`)}</span>.</span>
          )}
        </p>
        
        <div className="flex justify-center">
          <Link 
            to="/dashboard"
            className="bg-[#309D97] text-white py-2 px-4 rounded hover:bg-opacity-90 transition"
          >
            {t('common.backToDashboard')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized; 